export default "__VITE_PUBLIC_ASSET__f7436f71__"